import React from 'react';

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveIcon from '@mui/icons-material/Remove';
import {InputLabel} from "@material-ui/core";

export const TemplateArray = ({data, onCallback}) => {
    const onCallbackSend = () => {
        onCallback({target: {
                name: data.name,
                value: data.value
            }});
    }

    const onChangeItems = (e, index) => {
        e.preventDefault();
        const value = e.target.value;
        data.value[index] = value;
        onCallbackSend();
    }

    const onAddDescription = (e) => {
        e.preventDefault();
        data.value.push('');
        onCallbackSend();
    }

    const onDeleteDescription = (e, index) => {
        e.preventDefault();

        data.value.splice(index, 1);
        onCallbackSend();
    }

    return (
        <Box
            style={{padding: '10px', border: '1px solid #c4c4c4'}}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                justifyItems: "center",
                mt: 1
            }}
            noValidate
        >

            <Box>
                <InputLabel style={{position: 'absolute', top: '-10px', left: '5px'}} htmlFor={data.name}>
                    {data.headerName}
                </InputLabel>
            </Box>
            {data.value.map((item, ind) => (
                <Box key={ind} display={"flex"} alignItems={"center"} flexDirection={"row"}>
                    <TextField
                        margin="normal"
                        fullWidth
                        id={data.name + ind}
                        label={data.headerName}
                        name={data.name + ind}
                        value={item}
                        onChange={(e) => onChangeItems(e, ind)}
                    />
                    <Button><RemoveIcon onClick={(e) => onDeleteDescription(e, ind)}/></Button>
                </Box>
            ))}
            <Box display={"flex"} justifyContent={"center"}>
                <Button><ControlPointIcon onClick={(e) => onAddDescription(e)}/></Button>
            </Box>
        </Box>
    )
}
